export class TooltipElement {
    public label: string;
    public value: string;
    public type: string | null;
    public url: string | null;

    constructor(label: string, value: string, type: string | null = null,
        url: string | null = null) {

        this.label = label;
        this.value = value;
        this.type = type;
        this.url = url;
    }
}

export class TooltipColumnContent {
    public cellElement!: HTMLTableCellElement;
    public ttElement!: TooltipElement[];
}

export class TooltipHelper {
    public static getCellIndices(rows: JQuery<HTMLTableRowElement>, firstDataRow: number) {
        var ttCellIndices: { [key: string]: number; } = {};
        const firstRowCells = rows[firstDataRow].cells;
        for (let i = 0; i < firstRowCells.length; ++i) {
            const cell = firstRowCells[i] as any;
            if (cell.attributes.tooltip) {
                ttCellIndices[cell.attributes.tooltip.value] = i;
            }
        }

        return ttCellIndices;
    }

    public static getRowData(symbol: string, data: kendo.data.ObservableArray) {
        let rowData: any;
        for (let i = 0; i < data.length; ++i) {
            if (data[i].symbol == symbol) {
                rowData = data[i];
                break;
            }
        }

        return rowData;
    }

    public static createRowOfTooltips(ttRowContent: TooltipColumnContent[]) {
        if (!ttRowContent) {
            return;
        }

        for (let cell of ttRowContent) {
            let html = '<table>';
            for (const col of cell.ttElement) {
                html += TooltipHelper.getTooltipRow(col.label, col.value, col.type, col.url);
            }
            html += '</table>';

            $(cell.cellElement).kendoTooltip({
                content: html,
                showOn: 'click',
            });
        }
    }

    private static getTooltipRow(label: string, value: string, type: string | null,
        url: string | null) {

        let returnValue = `<tr class="mah-tooltip-tr"><td class="mah-tooltip-td-left">` +
            `${label}</td><td class="mah-tooltip-td-right">`;
        if (type === 'date') {
            if (!value) {
                returnValue += '';
            }
            else {
                const date = new Date(value);
                const month = date.getMonth() + 1;
                const dateOfMonth = date.getDate();
                const year = date.getFullYear();
                const formattedDate = `${month}/${dateOfMonth}/${year}`;
                returnValue += formattedDate;
            }
        }
        else if (url) {
            returnValue += `<a href="${url}" target="blank">${value}</a>`;
        }
        else {
            returnValue += value ?? '';
        }
        returnValue += `</td></tr>`;

        return returnValue;
    }
}
